import { defineMessages } from "react-intl";

export default defineMessages({
  serviceOfferCancelled: {
    id: "cancelledServiceOffer.serviceOfferCancelled",
    defaultMessage: "This service offer has been cancelled",
  },
});
